import React from 'react';
import { Icons, IconButton, Tooltip } from "@curves/ui-base";

const BatchActionDeleteGiftRecord = ({ getCheckedSourceData, openDialog, refresh }) => {
    const handleClick = () => {
        let params = getCheckedSourceData();
        if (params.length === 0) return;
        params = params.map((item) => item);

        if (typeof openDialog === 'function') openDialog(params, refresh);
    };
    return (
        <Tooltip title="批次刪除贈送">
            <IconButton onClick={handleClick}>
                <Icons.Trash />
            </IconButton>
        </Tooltip>
    );
};

export default BatchActionDeleteGiftRecord;
